import * as api from "../api";

export const fetchAllUsers = () => async (dispatch) => {
  try {
    const { data } = await api.fetchAllUsers();
    dispatch({ type: "FETCH_USERS", payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const updateProfile = (id, updateData) => async (dispatch) => {
  try {
    const { data } = await api.updateProfile(id, updateData);
    dispatch({ type: "UPDATE_CURRENT_USER", payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const giveBadgeForUpvote = (id, badgeData) => async (dispatch) => {
  try {
    const { data } = await api.giveBadgeForUpvote(id, badgeData);
    dispatch({ type: "ASSIGN_UPVOTE_BADGE", payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const giveBadgeForAnswer = (id, badgeData) => async (dispatch) => {
  try {
    const { data } = await api.giveBadgeForAnswer(id, badgeData);
    dispatch({ type: "ASSIGN_ANSWER_BADGE", payload: data });
  } catch (error) {
    console.log(error);
  }
};
